import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class MessageSms extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/message/sms'
        super(store, path)
    }

    send(id, showProgress) {
        return this._request({
            action: `${this._urlencode(id)}/send`,
            method: 'PATCH',
            showProgress
        })
    }

    sendDemo(id, showProgress) {
        return this._request({
            action: `${this._urlencode(id)}/demo`,
            method: 'PATCH',
            showProgress
        })
    }
}